<template>
  <div :class="{ labelColor: styleType === '3' }" class="unit_wrapper">
    <span
      v-if="salaryType === 2"
      :class="[styleType === '1' ? 'activityPosition' : '']"
      class="unit"
    >元/月</span
    >
    <span
      v-if="salaryType === 3"
      :class="[styleType === '1' ? 'activityPosition' : '']"
      class="unit"
    >元/周</span
    >
    <span
      v-if="salaryType === 4"
      :class="[styleType === '1' ? 'activityPosition' : '']"
      class="unit"
    >元/时</span
    >
    <span
      v-if="salaryType === 1"
      :class="[styleType === '1' ? 'activityPosition' : '']"
      class="unit"
    >元/年</span
    >
    <span
      v-if="salaryType === 5"
      :class="[styleType === '1' ? 'activityPosition' : '']"
      class="unit"
    >元/日</span
    >
    <span
      v-if="salaryType === 6 && styleType != '3'"
      :class="[
        styleType === '1' ? 'activityPosition' : '',
        styleType === '2' ? 'no_special' : '',
      ]"
      class="unit unit_special"
    >面议</span
    >
  </div>
</template>
<script>
export default {
  props: {
    salaryType: {
      type: Number,
      default() {
        return 3
      }
    },
    styleType: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/css/enterprise_color.scss";
.unit_wrapper {
  display: inline-block;
  .unit {
    color: $orange_weight;
    font-size: 16px;
  }
  .unit_special {
    margin-left: 20px;
  }
  .activityPosition {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
  .no_special {
    margin: 0;
  }
}
.labelColor {
  .unit {
    color: #666;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/model/unit.vue